import { apiClient } from "helpers/api_helper";
import { API } from "../constant/appointment.api";

export const getAllAppointments = async (data: object) => {
    try {
        const response = await apiClient.get(API.GetAllAppointment, data);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const getAppointmentDetailsById = async (id: any) => {
    try {
        const response = await apiClient.get(`${API.GetAppointmentDetailsById}`, id);
        return response;
    }
    catch (error: any) {
        throw new Error(error);
    }
};